/* ============
 * Product UN Code Transformer
 * ============
 *
 * The transformer for the product un code.
 */
import Transformer from './transformer';

export default class ProductUnCodeTransformer extends Transformer {

  static fetch(productUnCode) {
    const name = `${productUnCode.code} - ${productUnCode.title_translation_no}`;
    return {
      id: productUnCode.id,
      key: productUnCode.key,
      code: productUnCode.code,
      name,
    };
  }

  static send(productUnCode) {
    return {
      id: productUnCode.id,
      key: productUnCode.key,
      code: productUnCode.code,
      title_translation_no: productUnCode.value,
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/transformers/productUnCode.js